import {
    CHANGE_DATA_RANGE,
    CHANGE_SELECTION_STATUS,
    CHANGE_SELECTION_TECH,
    CHANGE_SELECTION_MODEL,
    CHANGE_SELECTION_SERIAL,
    CHANGE_SELECTION_PRODUCER,
    CHANGE_SELECTION_RANGE,
    CLEAR_FILTERS,
    CHANGE_CODE
} from "../constants";


const defalutFilters = {
    selectedTech: '',
    selectedModel: '',
    selectedStatus: '',
    dataRange: {
        from: '',
        to: ''
    },
    code: '',
    charSerial: '',
    rangeTime:'',
    selectedProducer:'',
}

const clearFilters = {
    selectedTech: '',
    selectedModel: '',
    selectedStatus: '',
    dataRange: {
        from: '',
        to: ''
    },
    code: '',
    charSerial: '',
    rangeTime:'',
    selectedProducer:'',
}

export default (filters = defalutFilters, action) => {

    const {type, payload} = action

    switch(type) {
        case CHANGE_DATA_RANGE:
            return {...filters, dataRange: {...payload}}

        case CHANGE_SELECTION_STATUS:
            return {...filters, selectedStatus: payload}

        case CHANGE_SELECTION_TECH:
            return {...filters, selectedTech: payload}

        case CHANGE_SELECTION_RANGE:
            return {...filters, rangeTime: payload}

        case CHANGE_SELECTION_MODEL:
            return {...filters, selectedModel: payload}

        case CHANGE_SELECTION_SERIAL:
            return {...filters, charSerial: payload}

        case CHANGE_CODE:
            return {...filters, code: payload}

        case CHANGE_SELECTION_PRODUCER:
                    return {...filters, selectedProducer: payload}

        case CLEAR_FILTERS:
            return clearFilters
        default:
            return filters
    }

}


// WEBPACK FOOTER //
// ./src/reducers/filters.js